export const INVITATION_SENDING_SETTINGS_QUERY_KEY = 'invitationSendingSettings';
export const LIVE_CHAT_GENERAL_SETTINGS_QUERY_KEY = 'liveChatGeneralSettings';
export const SUPPORT_TIMES_SETTINGS_QUERY_KEY = 'supportTimesSettings';
export const TAKE_OFFLINE_SETTINGS_QUERY_KEY = 'takeOfflineSettings';
export const USER_BLOCKING_SETTINGS_QUERY_KEY = 'userBlockingSettings';
